import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import About from "./components/About";
import Projects from "./components/Projects";
import Research from "./components/Research";
import Experience from "./components/Experience";
import Contact from "./components/Contacts";
import Skills from "./components/SKill";
import SimpleChatbot from "./components/SimpleChatbot";
import ChatBotModal from "./components/ChatBotModal";
import VoiceAssistant from "./components/VoiceAssistant";
import Academic from "./components/Academic";
import "./App.css";
import "./styles/global.css";

function App() {
  const [isAIModalOpen, setIsAIModalOpen] = useState(false);
  console.log({
    Layout,
    Header,
    Footer,
    HomePage,
    About,
    Projects,
    Research,
    Experience,
    Contact,
    Skills,
    SimpleChatbot,
    ChatBotModal,
    VoiceAssistant,
    Academic
  });

  return (
    <Router>

      <div className="App min-h-screen bg-[#112240]">
        {" "}
        {/* moved background here */}
        {/* keep the visible app content above the doodles */}
        <div className="min-h-screen flex flex-col relative z-10">
          {" "}
          {/* removed bg-slate-900 from here */}
          <Layout>
            <Header onOpenAIVoiceModal={() => setIsAIModalOpen(true)} />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<About />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/research" element={<Research />} />
                <Route path="/experience" element={<Experience />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/skills" element={<Skills />} />
                <Route path="/academic" element={<Academic />} />
              </Routes>
            </main>
            <Footer onOpenAIVoiceModal={() => setIsAIModalOpen(true)} />
          </Layout>
        </div>
        <ChatBotModal
          isOpen={isAIModalOpen}
          onClose={() => setIsAIModalOpen(false)}
        />
      </div>
      <VoiceAssistant />
    </Router>
  );
}

export default App;
